/* Upakarna collection "Load more" (brief 4.3: 24 per page, load more, no infinite scroll).
   Fetches the next page of the grid section and appends its cards. The control is a real link to ?page=N (P6.3), so
   crawlers and no-JS visitors follow it; Dawn's pagination links stay in the markup too and are hidden once this script
   runs. The link's href is kept in step with the next page so a middle-click or a copied link still works. */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('[data-upk-loadmore]');
    var grid = document.getElementById('product-grid');
    if (!wrap || !grid) return;
    var pag = document.querySelector('.pagination-wrapper');
    if (pag) pag.classList.add('upk-hidden');
    var btn = wrap.querySelector('a, button');
    if (!btn) return;
    var busy = false;
    btn.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; /* let a new-tab click follow the link */
      e.preventDefault();
      var next = wrap.getAttribute('data-next');
      if (!next || busy) return;
      busy = true; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-busy'); var label = btn.textContent; btn.textContent = 'Loading...';
      var url = new URL(next, location.origin);
      url.searchParams.set('section_id', grid.getAttribute('data-id'));
      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li.grid__item:not(.up-grid-injected)');
          items.forEach(function (li) { grid.appendChild(li); });
          var nextWrap = doc.querySelector('[data-upk-loadmore]');
          var nextUrl = nextWrap ? nextWrap.getAttribute('data-next') : '';
          if (nextUrl) { wrap.setAttribute('data-next', nextUrl); if (btn.tagName === 'A') btn.setAttribute('href', nextUrl); } else { wrap.remove(); }
          try { var u = new URL(location.href); u.searchParams.set('page', url.searchParams.get('page') || '2'); history.replaceState({}, '', u.toString()); } catch (err) {}
        })
        .catch(function () {})
        .then(function () { busy = false; btn.removeAttribute('aria-disabled'); btn.classList.remove('is-busy'); btn.textContent = label; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
